<div class="assignment-detail-container">

  <!-- Error State -->
  <div *ngIf="error" class="error-container">
    <div class="error-icon">⚠️</div>
    <p>{{ error }}</p>
    <button class="back-btn-error" (click)="goBack()">
      <i class="fas fa-arrow-left"></i>
      Back to Assignments
    </button>
  </div>

  <!-- Assignment Details -->
  <div *ngIf="!error && surveyInfo" class="detail-content">
    <!-- Survey Info Header -->
    <div class="survey-header">
      <div class="survey-badge">{{ surveyInfo.survey_number }}</div>
      <h1>{{ surveyInfo.survey_title }}</h1>
      <p class="survey-description" *ngIf="surveyInfo.survey_description">
        {{ surveyInfo.survey_description }}
      </p>
    </div>

    <!-- Employee Assignments -->
    <div class="employees-section">
      <h2>Assigned Employees & Customers</h2>
      
      <div *ngFor="let employee of employeeAssignments" class="employee-card">
        <!-- Employee Header -->
        <div class="employee-header">
          <div class="employee-info">
            <div class="employee-avatar">👤</div>
            <div>
              <h3>{{ employee.employee_name }}</h3>
              <p class="employee-code">{{ employee.employee_code }}</p>
            </div>
          </div>
          <div class="employee-stats">
            <div class="stat-item">
              <span class="stat-label">Total Customers</span>
              <span class="stat-value">{{ employee.customer_count }}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Completed</span>
              <span class="stat-value completed">{{ employee.completed_count }}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Pending</span>
              <span class="stat-value pending">{{ employee.pending_count }}</span>
            </div>
          </div>
        </div>

        <!-- Customers Table -->
        <div class="customers-table-container">
          <table class="customers-table">
            <thead>
              <tr>
                <th>Customer Name</th>
                <th>Assigned Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let customer of employee.customers">
                <td>
                  <div class="customer-name">{{ customer.customer_name }}</div>
                </td>
                <td>{{ formatDate(customer.assigned_date) }}</td>
                <td>
                  <span class="status-badge" [ngClass]="getStatusClass(customer.survey_status)">
                    {{ customer.survey_status }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- No Employees -->
      <div *ngIf="employeeAssignments.length === 0" class="no-employees">
        <div class="no-employees-icon">👥</div>
        <h3>No Employees Assigned</h3>
        <p>There are no employees assigned to this survey yet.</p>
      </div>
    </div>
  </div>
</div>